import React, { useMemo } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { useGetLookUpDropdownListQuery } from '../../api/endpoints/lookup';
import { useLanguage } from '../../contexts/LanguageContext';

/**
 * Alınan Teminatlar ekranındaki banka seçimi.
 * Projenin ortak lookup altyapısını kullanır (bkz. `CountryCodeDropdown.jsx`, `LaborGroupDropdown.jsx`
 * ile aynı desen): `v1/lookup/get?GroupCode=COLLATERAL_BANKS`. CollateralReceived modülüne özel
 * ayrı bir backend ucu yerine paylaşılan lookup ucu kullanılır.
 */
const CollateralBankDropdown = ({ value, onChange, className, placeholder, disabled = false }) => {
    const { getCurrentLanguageId } = useLanguage();

    const { data: raw = [], isLoading } = useGetLookUpDropdownListQuery({
        GroupCode: 'COLLATERAL_BANKS',
        LanguageId: getCurrentLanguageId() ?? 2
    });

    const options = useMemo(() => {
        const items = Array.isArray(raw) ? raw : Array.isArray(raw?.data) ? raw.data : [];
        return items.map((item) => {
            const name = item.translatedText || item.code || '';
            return { label: name, value: name };
        });
    }, [raw]);

    return (
        <Dropdown
            value={value || null}
            onChange={(e) => onChange?.(e.value)}
            options={options}
            optionLabel="label"
            optionValue="value"
            dataKey="value"
            className={className}
            placeholder={placeholder}
            disabled={disabled || isLoading}
            loading={isLoading}
            filter
            filterBy="label"
            showClear
            appendTo={document.body}
        />
    );
};

export default CollateralBankDropdown;
